import axios from './config';

export const getMissions = ({ queryStr, params }) => {
  return axios.get(`/missions?${queryStr}`, { params }).then(res => res.data.data);
};
